<ng-template #illegal>
    <app-page403></app-page403>
</ng-template>

<section *ngIf="!illegalUser; else illegal" class="mb-5">

    <!-- User List Section -->
    <div class="col-md-11">
        <h3>Users</h3>
        <div class="row mb-3">
            <div class="col-md-6">
                <mat-form-field>
                    <input matInput (keyup)="applyUserFilter($event.target.value)" placeholder="Filter users">
                </mat-form-field>
            </div>
            <div class="col-md-6 text-right">
                <button class="btn btn-success" (click)="openAddUserDialog()">
                    <i class="fa fa-plus"></i> Add User
                </button>
            </div>
        </div>

        <ng-container *ngIf="usersLoading">
            <div class="text-center my-4">
                <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="100"></mat-spinner>
            </div>
        </ng-container>

        <div *ngIf="usersError" class="alert alert-danger">{{ usersError }}</div>

        <div *ngIf="!usersLoading">
            <card>
                <div *ngIf="users.length > 0; else noUsers">
                    <table mat-table [dataSource]="userDataSource" class="mat-elevation-z8" matSort #userSort="matSort">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                        </ng-container>

                        <ng-container matColumnDef="username">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                            <td mat-cell *matCellDef="let element">{{ element.username }}</td>
                        </ng-container>

                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                        </ng-container>

                        <ng-container matColumnDef="organization">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
                            <td mat-cell *matCellDef="let element">{{ element.organization }}</td>
                        </ng-container>

                        <ng-container matColumnDef="access">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Access</th>
                            <td mat-cell *matCellDef="let element">{{ element.access }}</td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                            <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                        </ng-container>

                        <ng-container matColumnDef="enabled">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
                            <td mat-cell *matCellDef="let element">
                                <span [ngClass]="{'text-success': element.enabled, 'text-danger': !element.enabled}">
                                    {{ element.enabled ? 'Yes' : 'No' }}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button matTooltip="Edit" (click)="openEditUserDialog(element)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                <button mat-icon-button *ngIf="!element.enabled" matTooltip="Enable" (click)="confirmEnableUser(element)">
                                    <i class="fa fa-check-circle text-success"></i>
                                </button>
                                <button mat-icon-button *ngIf="element.enabled" matTooltip="Disable" (click)="confirmDisableUser(element)">
                                    <i class="fa fa-ban text-warning"></i>
                                </button>
                                <button mat-icon-button matTooltip="Resend Temp Password" (click)="confirmResendPassword(element)">
                                    <i class="fa fa-envelope"></i>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="userColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: userColumns;"></tr>
                    </table>
                    <mat-paginator #userPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                </div>
                <ng-template #noUsers>
                    <h4>No users found</h4>
                </ng-template>
            </card>
        </div>
    </div>

    <!-- User Events Section -->
    <div class="col-md-11 mt-5">
        <div class="d-flex justify-content-between align-items-center">
            <h3>User Events</h3>
            <button class="btn btn-outline-primary" (click)="downloadReport()" [disabled]="!events.length">
                <i class="fa fa-download"></i> Download Report
            </button>
        </div>
        <div class="row mb-3">
            <div class="col-md-12 d-flex flex-wrap align-items-start">
                <mat-form-field appearance="fill" class="matwidth mr-3">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="eventPicker">
                        <input matStartDate placeholder="Start Date" #eventStartInput>
                        <input matEndDate placeholder="End Date" #eventEndInput>
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="eventPicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #eventPicker></mat-date-range-picker>
                </mat-form-field>

                <mat-form-field appearance="fill" class="mr-3">
                    <mat-label>Username</mat-label>
                    <input matInput placeholder="Filter by username" #eventUsernameInput>
                </mat-form-field>

                <mat-form-field appearance="fill" class="mr-3">
                    <mat-label>Action</mat-label>
                    <mat-select #eventActionSelect>
                        <mat-option [value]="''">All</mat-option>
                        <mat-option *ngFor="let act of eventActionOptions" [value]="act">{{ act }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <button class="btn btn-success ml-3"
                        (click)="filterEvents(eventStartInput, eventEndInput, eventUsernameInput, eventActionSelect.value)">
                    Submit
                </button>
            </div>
        </div>

        <ng-container *ngIf="eventsLoading">
            <div class="text-center my-4">
                <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="100"></mat-spinner>
            </div>
        </ng-container>

        <div *ngIf="eventsError" class="alert alert-danger">{{ eventsError }}</div>

        <div *ngIf="!eventsLoading">
            <card>
                <div *ngIf="events.length > 0; else noEvents">
                    <table id="userEventsReport" mat-table [dataSource]="eventDataSource" class="mat-elevation-z8" matSort #eventSort="matSort">
                        <ng-container matColumnDef="eventDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                            <td mat-cell *matCellDef="let element">{{ element.Timestamp }}</td>
                        </ng-container>

                        <ng-container matColumnDef="eventType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Type</th>
                            <td mat-cell *matCellDef="let element">{{ element.EventType }}</td>
                        </ng-container>

                        <ng-container matColumnDef="username">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
                            <td mat-cell *matCellDef="let element">{{ element.UserId }}</td>
                        </ng-container>

                        <ng-container matColumnDef="adminUser">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Performed By</th>
                            <td mat-cell *matCellDef="let element">{{ element.AdminId }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="eventColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: eventColumns;"></tr>
                    </table>
                    <mat-paginator #eventPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    <div *ngIf="eventLastKey" class="text-center mt-2">
                        <button class="btn btn-outline-secondary" (click)="loadMoreEvents()">Load more results</button>
                    </div>
                </div>
                <ng-template #noEvents>
                    <h4>No events found for selected time range</h4>
                </ng-template>
            </card>
        </div>
    </div>

</section>
